var scope_0 = require('/vercel/workpath0/node_modules/mdx-deck/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/dc755bc442b6d5a18f19e633e534c7ea.js').default;export default
        Object.assign({}, scope_0 )
    